import { pointsMinCcv } from 'root/src/shared/constants/points';
import { isDevEnv } from 'root/src/shared/util/envSelect';
const DISABLED_POINTS_APPLICATIONS_DROP_IDS = [
    // Apex Legends
    'a458a4d8-f56a-45f7-a892-a8da60e3186c',
];
export const getCanEarnPoints = (params) => {
    var _a, _b;
    const creatorIsPartner = isDevEnv || params.isPartner;
    const dropId = (_a = params.dropEvent) === null || _a === void 0 ? void 0 : _a.id;
    if (dropId && DISABLED_POINTS_APPLICATIONS_DROP_IDS.includes(dropId) && !params.isCreatorPointsAllowlisted) {
        return false;
    }
    return (((_b = params.dropEvent) === null || _b === void 0 ? void 0 : _b.awardPoints)
        && params.ccv >= pointsMinCcv
        && params.isAbleToParticipate
        && creatorIsPartner)
        || params.isCreatorPointsAllowlisted;
};
